import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import cx from "classnames";
import "./style.less";
import { Link } from "gatsby-plugin-react-i18next";
import { fullWidth } from "components/Design/ArtDirectedImage";

const AyanaLogo = ({ image, className, multiLogo }) => {
  const images = fullWidth(image).images;

  return (
    <div className={cx(className, { "w-84": multiLogo, "w-173": !multiLogo })}>
      <picture className="w-173 h-46">
        {images.sources.map((src, index) => (
          <source
            key={index}
            type={src.type}
            sizes={src.sizes}
            src={src.src}
            srcSet={src.srcset}
          />
        ))}

        <img
          className={cx("w-173", {
            "h-46": !multiLogo,
          })}
          sizes={images.fallback.sizes}
          src={images.fallback.src}
          srcSet={images.fallback.srcset}
          loading="eager"
          alt="AYANA logo"
        />
      </picture>
    </div>
  );
};

const AyanaLogoFooterMobile = ({ image }) => {
  return (
    <div className="w-84 mx-auto">
      <GatsbyImage
        className="w-full"
        image={fullWidth(image)}
        loading="eager"
      />
    </div>
  );
};

const HeaderLogo = ({ hotel }) => {
  return (
    // Handle change logo by css to prevent blurred when scrolling page up/down
    <div className="header-logo color-only">
      <AyanaLogo image={hotel.logo_horizontal[0]} className="color-logo" />
    </div>
  );
};

const FooterLogo = ({ isMobile, hotel }) => {
  // Mobile
  if (isMobile) {
    return Boolean(Array.isArray(hotel.logo)) ? (
      hotel.logo.map((item) => (
        <Link to={item.caption} key={item.id}>
          <AyanaLogoFooterMobile image={item} />
        </Link>
      ))
    ) : (
      <AyanaLogoFooterMobile image={hotel.logo} />
    );
  }
  //Desktop
  return Boolean(Array.isArray(hotel.logo)) ? (
    hotel.logo.map((item) => (
      <Link to={item.caption} key={item.id}>
        <AyanaLogo image={item} multiLogo={Boolean(hotel.logo.length > 0)} />
      </Link>
    ))
  ) : (
    <AyanaLogo image={hotel.logo_horizontal[0]} />
  );
};

export { AyanaLogo, HeaderLogo, FooterLogo };
